module.exports = __webpack_public_path__ + "static/polarpumpen-casebg-min-560e5a7a0e09440d35ec1f9d7d21f222.jpg";